<h3 class="mode-title">Share the Gallery Link</h3>

<app-editable-gallery-url-field
  [gallery]="gallery"
  [accessLevel]="accessLevel"
  (onEditingPathChange)="isEditingPath = $event"
></app-editable-gallery-url-field>

<div *ngIf="!loading" class="main-container" [class.disabled]="isEditingPath">
  <div class="access-list-container">
    <div class="access-list">
      <div class="access-list-item">
        <div class="access-list-icon green" *ngIf="publicAccessLevel !== 'no_access'">
          <app-svg src="/assets/icons/link.svg"></app-svg>
        </div>
        <div class="access-list-icon red" *ngIf="publicAccessLevel === 'no_access'">
          <app-svg src="/assets/icons/link-disabled.svg"></app-svg>
        </div>
        <div class="access-list-info no-overflow-protect">
          <div class="info-main">Make link access available</div>
        </div>

        <div class="access-list-action">
          <div class="switch small" appTransitionPreventor>
            <input
              type="checkbox"
              id="allow-public-access"
              [(ngModel)]="allowAccess"
              [disabled]="accessLevel !== 'edit'"
              (ngModelChange)="togglePublicAccess()"
            />
            <label for="allow-public-access" data-test-id="allow-public-access"></label>
          </div>
        </div>
      </div>

      <ng-container *ngIf="allowAccess">
        <div class="access-list-item">
          <ng-container *ngIf="publicAccessLevel !== 'no_access' && !gallery.password_enabled">
            <div class="access-list-icon primary">
              <app-svg src="/assets/icons/incognito.svg"></app-svg>
            </div>
            <div class="access-list-info no-overflow-protect">
              <div class="info-main">Anyone with the link</div>
            </div>
          </ng-container>

          <ng-container *ngIf="publicAccessLevel !== 'no_access' && gallery.password_enabled">
            <div class="access-list-icon primary">
              <app-svg src="/assets/icons/incognito.svg"></app-svg>
            </div>
            <div class="access-list-info">
              <div class="info-main">Anyone with the link & password</div>
            </div>
          </ng-container>

          <div class="access-list-action">
            <app-gallery-share-context
              [accessLevel]="publicAccessLevel"
              [accessLevels]="publicAccessLevels"
              (onChange)="changePublicAccess($event)"
              [disabled]="isGalleryGuest || accessLevel !== 'edit'"
              [mode]="'link'"
            >
            </app-gallery-share-context>
          </div>
        </div>

        <div class="access-list-item">
          <div class="access-list-icon grey" *ngIf="!gallery.password_enabled">
            <app-svg src="/assets/icons/lock-off.svg"></app-svg>
          </div>
          <div class="access-list-icon orange" *ngIf="gallery.password_enabled">
            <app-svg src="/assets/icons/lock.svg"></app-svg>
          </div>

          <div class="access-list-info no-overflow-protect">
            <div class="info-main">
              Set a password
              <app-pro-tag
                permission="gallery.password"
                *ngIf="'!gallery.password' | permissions : gallery"
              ></app-pro-tag>
            </div>
          </div>

          <div class="access-list-action">
            <div class="switch small" appTransitionPreventor>
              <input
                type="checkbox"
                id="show-password"
                [(ngModel)]="showPassword"
                [disabled]="
                  (('!gallery.password' | permissions : gallery) && !gallery.password_enabled) || accessLevel !== 'edit'
                "
                (ngModelChange)="togglePassword()"
              />
              <label for="show-password" data-test-id="show-password"></label>
            </div>
          </div>
        </div>

        <ng-container *ngIf="showPassword">
          <div class="add-password-form" *ngIf="!addingPassword">
            <div class="field-and-button">
              <app-input-field [noLabel]="true" [smallNoLabel]="true" [noLabelExtraSpacing]="true">
                <div fake-input>• • • • • • • • •</div>
                <button
                  appButton
                  name="edit-password"
                  location="share-gallery-link"
                  [iconButton]="true"
                  color="simple-gray"
                  height="1"
                  (click)="addingPassword = true"
                  *appInputPost
                  class="edit-gallery-button"
                >
                  <app-svg src="/assets/icons/edit.svg"></app-svg>
                </button>
              </app-input-field>
              <button
                appButton
                type="button"
                name="copy-password"
                location="share-gallery-link"
                color="primary"
                spacing="3"
                size="1"
                weight="bold"
                [copy-clipboard]="gallery['password']"
                (click)="onPasswordCopied()"
              >
                Copy
              </button>
            </div>
          </div>

          <form [formGroup]="passwordForm" (ngSubmit)="savePassword()" *ngIf="addingPassword" class="add-password-form">
            <div class="field-and-button">
              <app-input-field
                [control]="passwordForm.controls.password"
                [noLabel]="true"
                [smallNoLabel]="true"
                [noLabelExtraSpacing]="true"
              >
                <input type="text" formControlName="password" placeholder="Password" appAutofocus />
              </app-input-field>
              <button
                appButton
                type="button"
                name="save-password"
                location="share-gallery-link"
                color="primary"
                spacing="3"
                size="1"
                weight="bold"
                (click)="savePassword()"
              >
                Save
              </button>
            </div>
          </form>
        </ng-container>

        <div class="access-list-item">
          <div
            class="access-list-icon"
            [class.grey]="!gallery.requires_user_identification"
            [class.primary]="gallery.requires_user_identification"
          >
            <app-svg src="/assets/icons/person-card.svg"></app-svg>
          </div>

          <div class="access-list-info no-overflow-protect">
            <div class="info-main">
              Require name and email
              <app-pro-tag
                permission="gallery.forceIdentification"
                *ngIf="'!gallery.forceIdentification' | permissions : gallery"
              ></app-pro-tag>
            </div>
          </div>

          <div class="access-list-action">
            <div class="switch small" appTransitionPreventor>
              <input
                type="checkbox"
                id="identify-visitors"
                [disabled]="
                  (('!gallery.forceIdentification' | permissions : gallery) && !gallery.requires_user_identification) ||
                  accessLevel !== 'edit'
                "
                [(ngModel)]="gallery.requires_user_identification"
                (ngModelChange)="saveRequiresIdentification()"
              />
              <label for="identify-visitors" data-test-id="identify-visitors"></label>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <app-share-gallery-social-links [gallery]="gallery" [disabled]="isEditingPath"></app-share-gallery-social-links>
</div>
